import { FC } from "react";
import "./style.scss";
import GoBack from "../../../../../assets/GoBackApp.svg";
import OpenCameraButton from "widgets/open-camera-btn";

import PassportEx from "../../../../../assets/PassportEx.svg";
import IdCardEx from "../../../../../assets/IdCardEx.svg";
import { useTranslation } from "react-i18next";

type PropType = {
  onClose: any;
  onOpen: any;
  type: "idCard" | "idCardBack" | "passport";
};

const PersonalDocumentModal: FC<PropType> = ({ type, onClose, onOpen }) => {
  const { t } = useTranslation("onboarding-auth");

  return (
    <div className="document-type-drawing-modal">
      <button className="goBack" onClick={onClose}>
        <img src={GoBack} alt="Go Back" />
      </button>
      <div
        className={`${
          type === "passport" ? "" : "examplePhotoBoxID"
        } examplePhotoBox`}
      >
        <img
          src={type === "passport" ? PassportEx : IdCardEx}
          alt="DocumentExample"
        />
      </div>

      <div className="textPDM">
        <p>
          {type === "passport"
            ? t("takePhotoOfPassport")
            : t("takePhotoOfIDCard")}
        </p>
        <span>
          {type === "passport"
            ? t("alignDocumentFrameCapture")
            : t("alignIDCardFrameCapture")}
        </span>
      </div>

      <OpenCameraButton onOpen={onOpen} />
    </div>
  );
};

export default PersonalDocumentModal;
